// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k-Nn","footer":"styles_footer__3pIPB"};